import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import NotificationService from '../../apiclients/NotificationService';
import WebsocketService from '../../apiclients/WebsocketService';
import Badge from '@material-ui/core/Badge';
import { isDeviceOnline } from '../../helpers';

const styles = {
    badge: {
        // top: '-5px',
        // right: '-5px',
        // fontSize: '10px',
        // width: '17px',
        // height: '17px',
    }
};

class NotificationsBadge extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notificationCount: 0
        };
        this.wsSubId = undefined;
    }

    componentDidMount() {
        this.refreshNotificationCount();
        this.refreshInterval = setInterval(this.refreshNotificationCount, 30 * 60000); // 30 Minutes or every reload/remount after specified cache TTL
        this.openWebSocketSubscription();
    }

    componentWillUnmount() {
        clearInterval(this.refreshInterval);
        WebsocketService.unsubscribe(this.wsSubId);
    }

    openWebSocketSubscription = async () => {
        this.wsSubId = await WebsocketService.subscribe(data => {
            this.refreshNotificationCount(0);
        }, 'NOTIFICATION');
    };

    refreshNotificationCount = async (cacheTTL = undefined) => {
        let isOnline = await isDeviceOnline();
        if (isOnline === true) {
            try {
                let response = await NotificationService.getNewMessageCount(cacheTTL);

                this.setState({ notificationCount: response.messageCount });
            } catch (err) {
                console.log(err);
            }
        }
    };

    render() {
        if (this.state.notificationCount !== undefined && this.state.notificationCount !== 0) {
            return (
                <Badge
                    badgeContent={this.state.notificationCount}
                    color="secondary"
                    classes={{
                        badge: this.props.classes.badge
                    }}
                >
                    {this.props.children}
                </Badge>
            );
        } else {
            return this.props.children;
        }
    }
}
NotificationsBadge.propTypes = {
    children: PropTypes.any,
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(NotificationsBadge);
